const tcnResponseTypes = {
  //******************TCN RESPONSE SEARCH DEAILS START******* */
  TCN_RESPONSE_SEARCH_START: "TCN_RESPONSE_SEARCH_START",
  TCN_RESPONSE_SEARCH_SUCCESS: "TCN_RESPONSE_SEARCH_SUCCESS",
  TCN_RESPONSE_SEARCH_FAILURE: "TCN_RESPONSE_SEARCH_FAILURE",
  TCN_RESPONSE_SEARCH_CHANGED: "TCN_RESPONSE_SEARCH_CAHNGED",
  TCN_RESPONSE_SEARCH_RESET: "TCN_RESPONSE_SEARCH_RESET",
  //******************TCN RESPONSE SEARCH DEAILS END**********/

  TCN_DISPOSITION_GROUP_START: "tcn_disposition_group_start",
  TCN_DISPOSITION_GROUP_SUCCESS: "tcn_disposition_group_success",
  TCN_DISPOSITION_GROUP_FAILURE: "tcn_disposition_group_failure",
  TCN_DISPOSITION_GROUP_RESPONSE_RESET_START:
    "tcn_disposition_group_response_reset_start",
  TCN_DISPOSITION_GROUP_RESPONSE_CHANGED:
    "tcn_disposition_group_response_changed",

  //********************TCN REPONSE EXPORT DETAILS START******/
  TCN_RESPONSE_EXPORT_START: "tcn_response_export_start",
  TCN_RESPONSE_EXPORT_SUCCESS: "tcn_response_export_success",
  TCN_RESPONSE_EXPORT_FAILURE: "tcn_response_export_failure",
  TCN_RESPONSE_EXPORT_RESET_START: "tcn_response_export_reset_start",
  TCN_RESPONSE_EXPORT_CHANGED: "tcn_response_export_changed",
  //********************TCN REPONSE EXPORT DETAILS END******/
};

export default tcnResponseTypes;
